<template>
<div class="app">
  <router-view />
</div>
</template>

<style>
/* @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai+Looped:wght@200;400&display=swap');
a {
    text-decoration: none !important;
  }

* {
    font-family: "IBM Plex Sans Thai Looped", sans-serif;
    font-weight: 400;
    font-style: normal;
}
*/

@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai+Looped&display=swap');

* {
  font-family: "Noto Sans Thai Looped", sans-serif;
  font-weight: 400;
  font-style: normal;
}
a {
  text-decoration: none !important;
}
</style>